<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <template v-if="data">
        <card-header>
          <router-link :to="{name: 'organization.list'}">Организации</router-link><!--
                    -->:
          <span class="text-secondary">#{{ data.id }}</span>
          {{ data.name }}
        </card-header>
        <tab-list>
          <tab-link to="organization.detail">Общая информация</tab-link>
          <tab-link to="organization.payment" v-if="can('module.payment.view')">Оплаты</tab-link>
          <tab-link to="organization.squad" v-if="can('module.squad.view')">Отряды</tab-link>
          <tab-link to="organization.squad-duty" v-if="can('module.squad.duty-view')">Смнены отрядов</tab-link>
          <tab-link to="organization.client-call-squad" v-if="can('module.client_call_squad.view')">Поиск отряда
          </tab-link>
        </tab-list>
        <card-body>
          <router-view :key="id" :data="data" @change="getData"></router-view>
        </card-body>
      </template>
    </spinner-block>
  </card-block>
</template>

<script>
export default {
  data: function () {
    return {
      data: null,
      dataProgress: true,
    }
  },
  props: {},
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.id) {
        axiosGetValue('/api/admin/organization/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
      }
    },
  },
}
</script>